import React from 'react'
import { useZocksQuota } from '../../../../../components/ScopedBlock/hooks'
import { Link } from 'react-router-dom'
import PrizeBadge from '../../../../../components/ScopedBlock/PrizeBadge.svg?url'
import { ScopedBlock } from '../../../../../components/ScopedBlock/ScopedBlock'
import { MissingScopeAction } from '../../../../../components/ScopedBlock/models'

export const DelegatedEmailUpgradeBanner: React.FC = () => {
  const { hasQuota } = useZocksQuota()

  if (hasQuota('integration.delegatedEmailEnabled.value')) {
    return null
  }

  return (
    <div className='d-flex align-items-center gap-2 zocks-p-0.75 rounded border zocks-bg-color-gray-100 zocks-mt-2'>
      <div className='text-nowrap'>
        <img alt='Upgrade' src={PrizeBadge} className='me-2' />
        <ScopedBlock
          scope={{
            scope: 'account:update',
            superScope: ['account:admin'],
          }}
          missingScopeAction={MissingScopeAction.REPLACE}
          replaceElement={<span className='paragraph-small'>Your plan doesn't include extra email addresses. Contact your Account Owner to upgrade.</span>}
        >
          <span className='paragraph-small'>
            Upgrade to link extra email addresses to your Zocks account.{' '}
            <Link to='/account/plan' className='zocks-text-primary text-decoration-underline'>
              Learn more
            </Link>
          </span>
        </ScopedBlock>
      </div>
    </div>
  )
}
